<template>
    <AppChartWrapper
            imageName="Top 10 Mentions by Facebook Pages"
    >
        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">
            Top 10 Mentions by Facebook Pages
        </h4>
        <TotalMentionBarChart
                class="pt-2"
                slot="chart"
                v-if="summaryDataReady"
                :chartData="facebookTopMentionChartData"
                :imgUrl="imgUrl"
                :options="options"
        />
    </AppChartWrapper>
</template>

<script>
	import {mapGetters} from "vuex";
	import _truncate from "lodash/truncate";
	import rabbit from "rabbit-node";
	import {abbrNum} from "../../utils";
	import TotalMentionBarChart from "./TotalMentionBarChart";
	import downloadChart from "@/mixins/downloadChart";
	import AppChartWrapper from "../AppChartWrapper";

	export default {
		name:"FacebookTopMentionGraph",
		components: {
			AppChartWrapper,
			TotalMentionBarChart
        },
        mixins:[downloadChart],
        props:{
			summaryDataReady:{
				type:Boolean,
            }
        },
		data() {
			return {
				images:[],
				options: {
					layout:{
						padding:{
							top: 17
                        }
                    },
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						display: false,
					},
					tooltips: {
						callbacks: {
							title(item) {
								return rabbit.uni2zg(this._data.labels[item[0].index].label);//show the whole string as tooltip title
							}
						},
						titleFontFamily: 'Zawgyi-One'
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									display: false
								},
								barThickness: 20,
								ticks: {
									fontFamily: 'Zawgyi-One',
									maxRotation: 30,
									fontSize: 12,
                                    callback({label}){
										return _truncate(rabbit.uni2zg(label),{length: 18})
                                    }
								}
							}
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									barThickness: 3,
									padding: 18,
									callback(value) {
										return abbrNum(value, 2);
									}
								},
							}
						]
					}
				}
			}
		},
		computed: {
			...mapGetters([
				"facebookPagesAndCount"
			]),

			facebookTopMentionChartData() {
				let labels = [], data = [];
				this.facebookPagesAndCount("fbposts").slice(0, 10).forEach((mention, index) => {
					labels.push({label:mention.name, imgUrl: this.imgUrl[index]});
					data.push(mention.count);
				});
				return {
					labels,
					datasets: [
						{
							backgroundColor: "#009fd6",
							data
						}
					]
				}
			},

			imgUrl() {
				return this.facebookPagesAndCount("fbposts").map(mention => `https://graph.facebook.com/${mention.id}/picture?width=50`).slice(0, 10)
			},
		},
	}
</script>
